import { HTTP } from './http-common'
import * as _ from 'lodash'

export default {
  endpoint: '/',
  omitUpdate: ['usuarioCreacion', 'propietario', 'group'],

  list (params) {
    let url = this.endpoint + '?'
    if (params) {
      for (let key in params) {
        url += key + '=' + params[key] + '&'
      }
    }
    return HTTP.get(url)
  },

  get (registroId, params) {
    let url = `${this.endpoint}/${registroId}?'`
    if (params) {
      for (let key in params) {
        url += key + '=' + params[key] + '&'
      }
    }
    return HTTP.get(url)
  },

  save (registro) {
    return HTTP.post(this.endpoint, registro)
  },

  update (registro) {
    let url = `${this.endpoint}/${registro.id}`
    registro = _.omit(registro, this.omitUpdate);
    return HTTP.patch(url, registro)
  },

  delete (registroId) {
    let url = `${this.endpoint}/${registroId}`
    return HTTP.delete(url)
  },

  count() {
    let url = `/total${this.endpoint}`
    return HTTP.get(url)
  },

  ownership(registro){
    let url = `${this.endpoint}/${registro.id}`
    if (_.isObject(registro.group)) {
      registro.group = registro.group.id
    }
    if (_.isObject(registro.propietario)) {
      registro.propietario = registro.propietario.id
    }
    registro = {id: registro.id, group: registro.group, propietario: registro.propietario}
    return HTTP.patch(url, registro)
  }

}



// WEBPACK FOOTER //
// ./src/services/apiService.js